export enum ModalType {
  Modal = 'MODAL',
  ConfirmationModal = 'CONFIRMATION_MODAL',
}

export type PopoverPlacement = 'top' | 'bottom' | 'left' | 'right';

export type IconType = 'info' | 'error';
